// Auto-generated by @vm0/firewalls-generator.
// Regenerate: cd turbo && pnpm -F @vm0/firewalls-generator generate
//
// DO NOT EDIT THIS FILE MANUALLY.
import type { FirewallRoutingIndexMetadata } from "./types";

export const FIREWALL_ROUTING_METADATA_INDEX = {
  "adzuna": {
    "type": "adzuna",
    "label": "Adzuna",
    "apis": [
      {
        "base": "https://api.adzuna.com"
      }
    ]
  },
  "agentmail": {
    "type": "agentmail",
    "label": "AgentMail",
    "apis": [
      {
        "base": "https://api.agentmail.to"
      }
    ]
  },
  "agora": {
    "type": "agora",
    "label": "Agora",
    "apis": [
      {
        "base": "https://api.agora.io"
      },
      {
        "base": "https://api.sd-rtn.com"
      }
    ]
  },
  "ahrefs": {
    "type": "ahrefs",
    "label": "Ahrefs",
    "apis": [
      {
        "base": "https://api.ahrefs.com"
      }
    ]
  },
  "airtable": {
    "type": "airtable",
    "label": "Airtable",
    "apis": [
      {
        "base": "https://api.airtable.com"
      }
    ]
  },
  "alchemy": {
    "type": "alchemy",
    "label": "Alchemy",
    "apis": [
      {
        "base": "https://{network}.g.alchemy.com"
      },
      {
        "base": "https://api.g.alchemy.com"
      }
    ]
  },
  "altium-365": {
    "type": "altium-365",
    "label": "Altium 365",
    "apis": [
      {
        "base": "${{ vars.ALTIUM365_WORKSPACE_URL }}"
      }
    ]
  },
  "amadeus": {
    "type": "amadeus",
    "label": "Amadeus",
    "apis": [
      {
        "base": "https://test.api.amadeus.com"
      },
      {
        "base": "https://api.amadeus.com"
      }
    ]
  },
  "amplitude": {
    "type": "amplitude",
    "label": "Amplitude",
    "apis": [
      {
        "base": "https://amplitude.com"
      },
      {
        "base": "https://analytics.eu.amplitude.com"
      },
      {
        "base": "https://api2.amplitude.com"
      },
      {
        "base": "https://api.eu.amplitude.com"
      }
    ]
  },
  "anthropic-managed-agents": {
    "type": "anthropic-managed-agents",
    "label": "Anthropic Managed Agents",
    "apis": [
      {
        "base": "https://api.anthropic.com"
      }
    ]
  },
  "apify": {
    "type": "apify",
    "label": "Apify",
    "apis": [
      {
        "base": "https://api.apify.com"
      }
    ]
  },
  "apollo": {
    "type": "apollo",
    "label": "Apollo",
    "apis": [
      {
        "base": "https://api.apollo.io"
      }
    ]
  },
  "asana": {
    "type": "asana",
    "label": "Asana",
    "apis": [
      {
        "base": "https://app.asana.com/api"
      }
    ]
  },
  "ashby": {
    "type": "ashby",
    "label": "Ashby",
    "apis": [
      {
        "base": "https://api.ashbyhq.com"
      }
    ]
  },
  "atlascloud": {
    "type": "atlascloud",
    "label": "Atlas Cloud",
    "apis": [
      {
        "base": "https://api.atlascloud.ai"
      }
    ]
  },
  "atlassian": {
    "type": "atlassian",
    "label": "Atlassian (Jira/Confluence)",
    "apis": [
      {
        "base": "https://api.atlassian.com"
      }
    ]
  },
  "attio": {
    "type": "attio",
    "label": "Attio",
    "apis": [
      {
        "base": "https://api.attio.com"
      }
    ]
  },
  "aviationstack": {
    "type": "aviationstack",
    "label": "AviationStack",
    "apis": [
      {
        "base": "https://api.aviationstack.com"
      }
    ]
  },
  "aws": {
    "type": "aws",
    "label": "AWS",
    "apis": [
      {
        "base": "https://{awsHost+}.amazonaws.com"
      },
      {
        "base": "https://{awsHost+}.amazonaws.com.cn"
      },
      {
        "base": "https://{awsHost+}.api.aws"
      }
    ]
  },
  "axiom": {
    "type": "axiom",
    "label": "Axiom",
    "apis": [
      {
        "base": "https://api.axiom.co"
      }
    ]
  },
  "base44": {
    "type": "base44",
    "label": "Base44",
    "apis": [
      {
        "base": "https://app.base44.com/mcp"
      },
      {
        "base": "https://app.base44.com/api/apps"
      }
    ]
  },
  "bentoml": {
    "type": "bentoml",
    "label": "BentoML",
    "apis": [
      {
        "base": "${{ vars.BENTO_CLOUD_API_ENDPOINT }}"
      },
      {
        "base": "https://{deployment+}.bentoml.ai"
      },
      {
        "base": "https://{deployment+}.cloud-apps.bentoml.com"
      }
    ]
  },
  "bfl": {
    "type": "bfl",
    "label": "Black Forest Labs",
    "apis": [
      {
        "base": "https://api.bfl.ai"
      },
      {
        "base": "https://api.eu.bfl.ai"
      },
      {
        "base": "https://api.us.bfl.ai"
      }
    ]
  },
  "bitrefill": {
    "type": "bitrefill",
    "label": "Bitrefill",
    "apis": [
      {
        "base": "https://api.bitrefill.com"
      }
    ]
  },
  "bitrix": {
    "type": "bitrix",
    "label": "Bitrix24",
    "apis": [
      {
        "base": "https://firewall-placeholder.vm3.ai/bitrix/hook"
      }
    ]
  },
  "bland": {
    "type": "bland",
    "label": "Bland",
    "apis": [
      {
        "base": "https://api.bland.ai"
      }
    ]
  },
  "box": {
    "type": "box",
    "label": "Box",
    "apis": [
      {
        "base": "https://api.box.com"
      },
      {
        "base": "https://upload.box.com"
      }
    ]
  },
  "brave-search": {
    "type": "brave-search",
    "label": "Brave Search",
    "apis": [
      {
        "base": "https://api.search.brave.com"
      }
    ]
  },
  "brevo": {
    "type": "brevo",
    "label": "Brevo",
    "apis": [
      {
        "base": "https://api.brevo.com"
      }
    ]
  },
  "brex": {
    "type": "brex",
    "label": "Brex",
    "apis": [
      {
        "base": "https://api.brex.com"
      }
    ]
  },
  "bright-data": {
    "type": "bright-data",
    "label": "Bright Data",
    "apis": [
      {
        "base": "https://api.brightdata.com"
      }
    ]
  },
  "browser-use": {
    "type": "browser-use",
    "label": "Browser Use",
    "apis": [
      {
        "base": "https://api.browser-use.com"
      }
    ]
  },
  "browserbase": {
    "type": "browserbase",
    "label": "Browserbase",
    "apis": [
      {
        "base": "https://api.browserbase.com"
      }
    ]
  },
  "browserless": {
    "type": "browserless",
    "label": "Browserless",
    "apis": [
      {
        "base": "https://production-sfo.browserless.io"
      },
      {
        "base": "https://production-lon.browserless.io"
      },
      {
        "base": "https://production-ams.browserless.io"
      }
    ]
  },
  "browserstack": {
    "type": "browserstack",
    "label": "BrowserStack",
    "apis": [
      {
        "base": "https://api.browserstack.com"
      },
      {
        "base": "https://api-cloud.browserstack.com"
      },
      {
        "base": "https://www.browserstack.com"
      }
    ]
  },
  "bubblemaps": {
    "type": "bubblemaps",
    "label": "Bubblemaps",
    "apis": [
      {
        "base": "https://api.bubblemaps.io"
      }
    ]
  },
  "buffer": {
    "type": "buffer",
    "label": "Buffer",
    "apis": [
      {
        "base": "https://api.buffer.com"
      },
      {
        "base": "https://api.bufferapp.com"
      }
    ]
  },
  "builtwith": {
    "type": "builtwith",
    "label": "BuiltWith",
    "apis": [
      {
        "base": "https://api.builtwith.com"
      }
    ]
  },
  "cal-com": {
    "type": "cal-com",
    "label": "Cal.com",
    "apis": [
      {
        "base": "https://api.cal.com"
      }
    ]
  },
  "calendly": {
    "type": "calendly",
    "label": "Calendly",
    "apis": [
      {
        "base": "https://api.calendly.com"
      }
    ]
  },
  "canva": {
    "type": "canva",
    "label": "Canva",
    "apis": [
      {
        "base": "https://api.canva.com"
      }
    ]
  },
  "chatwoot": {
    "type": "chatwoot",
    "label": "Chatwoot",
    "apis": [
      {
        "base": "https://app.chatwoot.com"
      }
    ]
  },
  "checkr": {
    "type": "checkr",
    "label": "Checkr",
    "apis": [
      {
        "base": "https://api.checkr.com/v1"
      }
    ]
  },
  "clado": {
    "type": "clado",
    "label": "Clado",
    "apis": [
      {
        "base": "https://search.clado.ai"
      }
    ]
  },
  "clearbit": {
    "type": "clearbit",
    "label": "Clearbit",
    "apis": [
      {
        "base": "https://person.clearbit.com"
      },
      {
        "base": "https://person-stream.clearbit.com"
      },
      {
        "base": "https://company.clearbit.com"
      },
      {
        "base": "https://reveal.clearbit.com"
      },
      {
        "base": "https://risk.clearbit.com"
      }
    ]
  },
  "clerk": {
    "type": "clerk",
    "label": "Clerk",
    "apis": [
      {
        "base": "https://api.clerk.com"
      }
    ]
  },
  "clickup": {
    "type": "clickup",
    "label": "ClickUp",
    "apis": [
      {
        "base": "https://api.clickup.com/api"
      }
    ]
  },
  "close": {
    "type": "close",
    "label": "Close",
    "apis": [
      {
        "base": "https://api.close.com/api"
      }
    ]
  },
  "cloudflare": {
    "type": "cloudflare",
    "label": "Cloudflare",
    "apis": [
      {
        "base": "https://api.cloudflare.com/client"
      },
      {
        "base": "https://api.cloudflare.com/client"
      }
    ]
  },
  "coda": {
    "type": "coda",
    "label": "Coda",
    "apis": [
      {
        "base": "https://coda.io"
      }
    ]
  },
  "coingecko": {
    "type": "coingecko",
    "label": "CoinGecko",
    "apis": [
      {
        "base": "https://api.coingecko.com"
      },
      {
        "base": "https://pro-api.coingecko.com"
      }
    ]
  },
  "coresignal": {
    "type": "coresignal",
    "label": "Coresignal",
    "apis": [
      {
        "base": "https://api.coresignal.com"
      }
    ]
  },
  "cronlytic": {
    "type": "cronlytic",
    "label": "Cronlytic",
    "apis": [
      {
        "base": "https://api.cronlytic.com"
      }
    ]
  },
  "crustdata": {
    "type": "crustdata",
    "label": "Crustdata",
    "apis": [
      {
        "base": "https://api.crustdata.com"
      }
    ]
  },
  "cursor": {
    "type": "cursor",
    "label": "Cursor",
    "apis": [
      {
        "base": "https://api.cursor.com"
      }
    ]
  },
  "customer-io": {
    "type": "customer-io",
    "label": "Customer.io",
    "apis": [
      {
        "base": "https://api.customer.io"
      }
    ]
  },
  "daytona": {
    "type": "daytona",
    "label": "Daytona",
    "apis": [
      {
        "base": "https://app.daytona.io/api"
      },
      {
        "base": "https://proxy.app.daytona.io/toolbox"
      }
    ]
  },
  "db9": {
    "type": "db9",
    "label": "db9",
    "apis": [
      {
        "base": "https://api.db9.ai"
      }
    ]
  },
  "deel": {
    "type": "deel",
    "label": "Deel",
    "apis": [
      {
        "base": "https://api.letsdeel.com"
      }
    ]
  },
  "deepseek": {
    "type": "deepseek",
    "label": "DeepSeek",
    "apis": [
      {
        "base": "https://api.deepseek.com"
      }
    ]
  },
  "defillama": {
    "type": "defillama",
    "label": "DefiLlama",
    "apis": [
      {
        "base": "https://pro-api.llama.fi/CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCof"
      }
    ]
  },
  "devto": {
    "type": "devto",
    "label": "Dev.to",
    "apis": [
      {
        "base": "https://dev.to/api"
      }
    ]
  },
  "diffbot": {
    "type": "diffbot",
    "label": "Diffbot",
    "apis": [
      {
        "base": "https://api.diffbot.com"
      }
    ]
  },
  "dify": {
    "type": "dify",
    "label": "Dify",
    "apis": [
      {
        "base": "https://api.dify.ai"
      }
    ]
  },
  "discord": {
    "type": "discord",
    "label": "Discord",
    "apis": [
      {
        "base": "https://discord.com/api"
      }
    ]
  },
  "discord-webhook": {
    "type": "discord-webhook",
    "label": "Discord Webhook",
    "apis": [
      {
        "base": "https://firewall-placeholder.vm3.ai/discord-webhook/hook"
      }
    ]
  },
  "docusign": {
    "type": "docusign",
    "label": "DocuSign",
    "apis": [
      {
        "base": "https://www.docusign.net"
      },
      {
        "base": "https://na2.docusign.net"
      },
      {
        "base": "https://na3.docusign.net"
      },
      {
        "base": "https://na4.docusign.net"
      },
      {
        "base": "https://eu.docusign.net"
      },
      {
        "base": "https://au.docusign.net"
      },
      {
        "base": "https://ca.docusign.net"
      },
      {
        "base": "https://demo.docusign.net"
      },
      {
        "base": "https://account.docusign.com"
      },
      {
        "base": "https://account-d.docusign.com"
      }
    ]
  },
  "doppler": {
    "type": "doppler",
    "label": "Doppler",
    "apis": [
      {
        "base": "https://api.doppler.com"
      }
    ]
  },
  "doubao": {
    "type": "doubao",
    "label": "Doubao",
    "apis": [
      {
        "base": "https://openspeech.bytedance.com"
      }
    ]
  },
  "drive9": {
    "type": "drive9",
    "label": "drive9",
    "apis": [
      {
        "base": "https://api.drive9.ai"
      }
    ]
  },
  "dropbox": {
    "type": "dropbox",
    "label": "Dropbox",
    "apis": [
      {
        "base": "https://api.dropboxapi.com"
      },
      {
        "base": "https://content.dropboxapi.com"
      },
      {
        "base": "https://notify.dropboxapi.com"
      }
    ]
  },
  "dropbox-sign": {
    "type": "dropbox-sign",
    "label": "Dropbox Sign",
    "apis": [
      {
        "base": "https://api.hellosign.com"
      }
    ]
  },
  "duffel": {
    "type": "duffel",
    "label": "Duffel",
    "apis": [
      {
        "base": "https://api.duffel.com"
      }
    ]
  },
  "e2b": {
    "type": "e2b",
    "label": "E2B",
    "apis": [
      {
        "base": "https://api.e2b.app"
      }
    ]
  },
  "elevenlabs": {
    "type": "elevenlabs",
    "label": "ElevenLabs",
    "apis": [
      {
        "base": "https://api.elevenlabs.io"
      }
    ]
  },
  "etherscan": {
    "type": "etherscan",
    "label": "Etherscan",
    "apis": [
      {
        "base": "https://api.etherscan.io/v2/api"
      }
    ]
  },
  "etsy": {
    "type": "etsy",
    "label": "Etsy",
    "apis": [
      {
        "base": "https://openapi.etsy.com"
      }
    ]
  },
  "exa": {
    "type": "exa",
    "label": "Exa",
    "apis": [
      {
        "base": "https://api.exa.ai"
      }
    ]
  },
  "explorium": {
    "type": "explorium",
    "label": "Explorium",
    "apis": [
      {
        "base": "https://api.explorium.ai"
      }
    ]
  },
  "faire": {
    "type": "faire",
    "label": "Faire",
    "apis": [
      {
        "base": "https://www.faire.com/external-api/v2"
      }
    ]
  },
  "fal": {
    "type": "fal",
    "label": "fal.ai",
    "apis": [
      {
        "base": "https://fal.run"
      },
      {
        "base": "https://queue.fal.run"
      },
      {
        "base": "https://api.fal.ai"
      }
    ]
  },
  "figma": {
    "type": "figma",
    "label": "Figma",
    "apis": [
      {
        "base": "https://api.figma.com"
      }
    ]
  },
  "firecrawl": {
    "type": "firecrawl",
    "label": "Firecrawl",
    "apis": [
      {
        "base": "https://api.firecrawl.dev"
      }
    ]
  },
  "fireflies": {
    "type": "fireflies",
    "label": "Fireflies",
    "apis": [
      {
        "base": "https://api.fireflies.ai/graphql"
      }
    ]
  },
  "flightaware": {
    "type": "flightaware",
    "label": "FlightAware",
    "apis": [
      {
        "base": "https://aeroapi.flightaware.com"
      }
    ]
  },
  "freshdesk": {
    "type": "freshdesk",
    "label": "Freshdesk",
    "apis": [
      {
        "base": "https://${{ vars.FRESHDESK_DOMAIN }}.freshdesk.com"
      }
    ]
  },
  "gamma": {
    "type": "gamma",
    "label": "Gamma",
    "apis": [
      {
        "base": "https://public-api.gamma.app"
      }
    ]
  },
  "garmin-connect": {
    "type": "garmin-connect",
    "label": "Garmin Connect",
    "apis": [
      {
        "base": "https://apis.garmin.com"
      }
    ]
  },
  "gemini": {
    "type": "gemini",
    "label": "Gemini",
    "apis": [
      {
        "base": "https://generativelanguage.googleapis.com"
      }
    ]
  },
  "github": {
    "type": "github",
    "label": "GitHub",
    "apis": [
      {
        "base": "https://api.github.com"
      },
      {
        "base": "https://uploads.github.com"
      },
      {
        "base": "https://github.com/{owner}/{repo}.git"
      },
      {
        "base": "https://gist.github.com/{gist_id}.git"
      },
      {
        "base": "https://gist.github.com/{user}/{gist_id}.git"
      },
      {
        "base": "https://raw.githubusercontent.com/{owner}/{repo}"
      },
      {
        "base": "https://codeload.github.com/{owner}/{repo}"
      },
      {
        "base": "https://npm.pkg.github.com"
      }
    ]
  },
  "gitlab": {
    "type": "gitlab",
    "label": "GitLab",
    "apis": [
      {
        "base": "https://gitlab.com/api"
      }
    ]
  },
  "gmail": {
    "type": "gmail",
    "label": "Gmail",
    "apis": [
      {
        "base": "https://gmail.googleapis.com/gmail"
      },
      {
        "base": "https://gmail.googleapis.com/upload/gmail"
      },
      {
        "base": "https://gmail.googleapis.com/resumable/upload/gmail"
      }
    ]
  },
  "gong": {
    "type": "gong",
    "label": "Gong",
    "apis": [
      {
        "base": "https://${{ vars.GONG_API_BASE }}"
      }
    ]
  },
  "google-ads": {
    "type": "google-ads",
    "label": "Google Ads",
    "apis": [
      {
        "base": "https://googleads.googleapis.com"
      },
      {
        "base": "https://datamanager.googleapis.com"
      }
    ]
  },
  "google-analytics": {
    "type": "google-analytics",
    "label": "Google Analytics",
    "apis": [
      {
        "base": "https://analyticsdata.googleapis.com"
      },
      {
        "base": "https://analyticsadmin.googleapis.com"
      }
    ]
  },
  "google-calendar": {
    "type": "google-calendar",
    "label": "Google Calendar",
    "apis": [
      {
        "base": "https://www.googleapis.com/calendar"
      }
    ]
  },
  "google-cloud": {
    "type": "google-cloud",
    "label": "Google Cloud",
    "apis": [
      {
        "base": "https://cloudresourcemanager.googleapis.com"
      },
      {
        "base": "https://serviceusage.googleapis.com"
      },
      {
        "base": "https://iam.googleapis.com"
      },
      {
        "base": "https://compute.googleapis.com"
      },
      {
        "base": "https://appengine.googleapis.com"
      },
      {
        "base": "https://sqladmin.googleapis.com"
      },
      {
        "base": "https://bigquery.googleapis.com"
      },
      {
        "base": "https://storage.googleapis.com"
      },
      {
        "base": "https://run.googleapis.com"
      },
      {
        "base": "https://cloudbuild.googleapis.com"
      },
      {
        "base": "https://artifactregistry.googleapis.com"
      },
      {
        "base": "https://container.googleapis.com"
      },
      {
        "base": "https://cloudfunctions.googleapis.com"
      },
      {
        "base": "https://secretmanager.googleapis.com"
      },
      {
        "base": "https://logging.googleapis.com"
      },
      {
        "base": "https://monitoring.googleapis.com"
      },
      {
        "base": "https://cloudbilling.googleapis.com"
      },
      {
        "base": "https://pubsub.googleapis.com"
      },
      {
        "base": "https://firestore.googleapis.com"
      },
      {
        "base": "https://spanner.googleapis.com"
      }
    ]
  },
  "google-docs": {
    "type": "google-docs",
    "label": "Google Docs",
    "apis": [
      {
        "base": "https://docs.googleapis.com"
      }
    ]
  },
  "google-drive": {
    "type": "google-drive",
    "label": "Google Drive",
    "apis": [
      {
        "base": "https://www.googleapis.com/drive"
      },
      {
        "base": "https://www.googleapis.com/upload/drive"
      },
      {
        "base": "https://www.googleapis.com/resumable/upload/drive"
      }
    ]
  },
  "google-maps": {
    "type": "google-maps",
    "label": "Google Maps",
    "apis": [
      {
        "base": "https://geocode.googleapis.com"
      },
      {
        "base": "https://places.googleapis.com"
      },
      {
        "base": "https://routes.googleapis.com"
      }
    ]
  },
  "google-meet": {
    "type": "google-meet",
    "label": "Google Meet",
    "apis": [
      {
        "base": "https://meet.googleapis.com"
      },
      {
        "base": "https://workspaceevents.googleapis.com"
      }
    ]
  },
  "google-search-console": {
    "type": "google-search-console",
    "label": "Google Search Console",
    "apis": [
      {
        "base": "https://searchconsole.googleapis.com"
      }
    ]
  },
  "google-sheets": {
    "type": "google-sheets",
    "label": "Google Sheets",
    "apis": [
      {
        "base": "https://sheets.googleapis.com"
      }
    ]
  },
  "granola": {
    "type": "granola",
    "label": "Granola",
    "apis": [
      {
        "base": "https://public-api.granola.ai"
      }
    ]
  },
  "greenhouse": {
    "type": "greenhouse",
    "label": "Greenhouse",
    "apis": [
      {
        "base": "https://harvest.greenhouse.io"
      }
    ]
  },
  "groq": {
    "type": "groq",
    "label": "Groq",
    "apis": [
      {
        "base": "https://api.groq.com"
      }
    ]
  },
  "gumroad": {
    "type": "gumroad",
    "label": "Gumroad",
    "apis": [
      {
        "base": "https://api.gumroad.com"
      }
    ]
  },
  "helicone": {
    "type": "helicone",
    "label": "Helicone",
    "apis": [
      {
        "base": "https://api.helicone.ai"
      }
    ]
  },
  "heygen": {
    "type": "heygen",
    "label": "HeyGen",
    "apis": [
      {
        "base": "https://api.heygen.com"
      },
      {
        "base": "https://upload.heygen.com"
      }
    ]
  },
  "hitem3d": {
    "type": "hitem3d",
    "label": "Hitem3D",
    "apis": [
      {
        "base": "https://api.hitem3d.ai/open-api/v1/auth/token"
      },
      {
        "base": "https://mcp.hitem3d.ai/mcp"
      }
    ]
  },
  "honcho": {
    "type": "honcho",
    "label": "Honcho",
    "apis": [
      {
        "base": "https://api.honcho.dev"
      }
    ]
  },
  "htmlcsstoimage": {
    "type": "htmlcsstoimage",
    "label": "HTML/CSS to Image",
    "apis": [
      {
        "base": "https://hcti.io"
      }
    ]
  },
  "hubspot": {
    "type": "hubspot",
    "label": "HubSpot",
    "apis": [
      {
        "base": "https://api.hubapi.com"
      }
    ]
  },
  "hugging-face": {
    "type": "hugging-face",
    "label": "Hugging Face",
    "apis": [
      {
        "base": "https://huggingface.co/api"
      },
      {
        "base": "https://api-inference.huggingface.co"
      },
      {
        "base": "https://router.huggingface.co"
      }
    ]
  },
  "hume": {
    "type": "hume",
    "label": "Hume",
    "apis": [
      {
        "base": "https://api.hume.ai"
      }
    ]
  },
  "hunter": {
    "type": "hunter",
    "label": "Hunter",
    "apis": [
      {
        "base": "https://api.hunter.io"
      }
    ]
  },
  "imgur": {
    "type": "imgur",
    "label": "Imgur",
    "apis": [
      {
        "base": "https://api.imgur.com"
      }
    ]
  },
  "infisical": {
    "type": "infisical",
    "label": "Infisical",
    "apis": [
      {
        "base": "https://us.infisical.com"
      },
      {
        "base": "https://eu.infisical.com"
      },
      {
        "base": "https://app.infisical.com"
      }
    ]
  },
  "insforge": {
    "type": "insforge",
    "label": "InsForge",
    "apis": [
      {
        "base": "https://${{ vars.INSFORGE_DOMAIN }}"
      }
    ]
  },
  "instagram": {
    "type": "instagram",
    "label": "Instagram",
    "apis": [
      {
        "base": "https://graph.instagram.com"
      },
      {
        "base": "https://graph.facebook.com"
      }
    ]
  },
  "instantly": {
    "type": "instantly",
    "label": "Instantly",
    "apis": [
      {
        "base": "https://api.instantly.ai"
      }
    ]
  },
  "intercom": {
    "type": "intercom",
    "label": "Intercom",
    "apis": [
      {
        "base": "https://api.intercom.io"
      }
    ]
  },
  "intervals-icu": {
    "type": "intervals-icu",
    "label": "Intervals.icu",
    "apis": [
      {
        "base": "https://intervals.icu"
      }
    ]
  },
  "ironclad": {
    "type": "ironclad",
    "label": "Ironclad",
    "apis": [
      {
        "base": "https://${{ vars.IRONCLAD_HOST }}"
      }
    ]
  },
  "jam": {
    "type": "jam",
    "label": "Jam",
    "apis": [
      {
        "base": "https://mcp.jam.dev"
      }
    ]
  },
  "jira": {
    "type": "jira",
    "label": "Jira",
    "apis": [
      {
        "base": "https://${{ vars.JIRA_DOMAIN }}"
      }
    ]
  },
  "jotform": {
    "type": "jotform",
    "label": "Jotform",
    "apis": [
      {
        "base": "https://api.jotform.com"
      },
      {
        "base": "https://eu-api.jotform.com"
      },
      {
        "base": "https://hipaa-api.jotform.com"
      }
    ]
  },
  "klaviyo": {
    "type": "klaviyo",
    "label": "Klaviyo",
    "apis": [
      {
        "base": "https://a.klaviyo.com"
      }
    ]
  },
  "kommo": {
    "type": "kommo",
    "label": "Kommo",
    "apis": [
      {
        "base": "https://${{ vars.KOMMO_SUBDOMAIN }}.kommo.com"
      }
    ]
  },
  "langfuse": {
    "type": "langfuse",
    "label": "Langfuse",
    "apis": [
      {
        "base": "https://cloud.langfuse.com"
      },
      {
        "base": "https://us.cloud.langfuse.com"
      }
    ]
  },
  "langsmith": {
    "type": "langsmith",
    "label": "LangSmith",
    "apis": [
      {
        "base": "https://api.smith.langchain.com"
      }
    ]
  },
  "lark": {
    "type": "lark",
    "label": "Lark",
    "apis": [
      {
        "base": "https://open.larksuite.com"
      }
    ]
  },
  "line": {
    "type": "line",
    "label": "LINE",
    "apis": [
      {
        "base": "https://api.line.me"
      }
    ]
  },
  "linear": {
    "type": "linear",
    "label": "Linear",
    "apis": [
      {
        "base": "https://api.linear.app"
      }
    ]
  },
  "loops": {
    "type": "loops",
    "label": "Loops",
    "apis": [
      {
        "base": "https://app.loops.so/api"
      }
    ]
  },
  "luma": {
    "type": "luma",
    "label": "Luma",
    "apis": [
      {
        "base": "https://public-api.luma.com"
      }
    ]
  },
  "luma-ai": {
    "type": "luma-ai",
    "label": "Luma AI",
    "apis": [
      {
        "base": "https://api.lumalabs.ai"
      }
    ]
  },
  "mailchimp": {
    "type": "mailchimp",
    "label": "Mailchimp",
    "apis": [
      {
        "base": "https://{dc}.api.mailchimp.com"
      },
      {
        "base": "https://login.mailchimp.com"
      }
    ]
  },
  "mailsac": {
    "type": "mailsac",
    "label": "Mailsac",
    "apis": [
      {
        "base": "https://mailsac.com"
      }
    ]
  },
  "make": {
    "type": "make",
    "label": "Make",
    "apis": [
      {
        "base": "https://eu1.make.com"
      },
      {
        "base": "https://eu2.make.com"
      },
      {
        "base": "https://us1.make.com"
      },
      {
        "base": "https://us2.make.com"
      },
      {
        "base": "https://eu1.make.celonis.com"
      },
      {
        "base": "https://us1.make.celonis.com"
      }
    ]
  },
  "manus": {
    "type": "manus",
    "label": "Manus",
    "apis": [
      {
        "base": "https://api.manus.ai"
      }
    ]
  },
  "mapbox": {
    "type": "mapbox",
    "label": "Mapbox",
    "apis": [
      {
        "base": "https://api.mapbox.com"
      }
    ]
  },
  "maskdb": {
    "type": "maskdb",
    "label": "maskdb",
    "apis": [
      {
        "base": "https://api.maskdb.ai"
      }
    ]
  },
  "massive": {
    "type": "massive",
    "label": "Massive (Polygon.io)",
    "apis": [
      {
        "base": "https://api.massive.com"
      },
      {
        "base": "https://api.polygon.io"
      }
    ]
  },
  "mathpix": {
    "type": "mathpix",
    "label": "Mathpix",
    "apis": [
      {
        "base": "https://api.mathpix.com"
      }
    ]
  },
  "mem0": {
    "type": "mem0",
    "label": "Mem0",
    "apis": [
      {
        "base": "https://api.mem0.ai"
      }
    ]
  },
  "mercury": {
    "type": "mercury",
    "label": "Mercury",
    "apis": [
      {
        "base": "https://api.mercury.com"
      }
    ]
  },
  "meshy": {
    "type": "meshy",
    "label": "Meshy",
    "apis": [
      {
        "base": "https://api.meshy.ai"
      }
    ]
  },
  "meta-ads": {
    "type": "meta-ads",
    "label": "Meta Ads",
    "apis": [
      {
        "base": "https://graph.facebook.com"
      },
      {
        "base": "https://graph.facebook.com"
      }
    ]
  },
  "metabase": {
    "type": "metabase",
    "label": "Metabase",
    "apis": [
      {
        "base": "${{ vars.METABASE_BASE_URL }}"
      }
    ]
  },
  "microsoft-365": {
    "type": "microsoft-365",
    "label": "Microsoft 365",
    "apis": [
      {
        "base": "https://graph.microsoft.com"
      }
    ]
  },
  "minimax": {
    "type": "minimax",
    "label": "MiniMax",
    "apis": [
      {
        "base": "https://api.minimax.io"
      }
    ]
  },
  "miro": {
    "type": "miro",
    "label": "Miro",
    "apis": [
      {
        "base": "https://api.miro.com"
      }
    ]
  },
  "mixpanel": {
    "type": "mixpanel",
    "label": "Mixpanel",
    "apis": [
      {
        "base": "https://mixpanel.com"
      },
      {
        "base": "https://data.mixpanel.com"
      },
      {
        "base": "https://api.mixpanel.com"
      }
    ]
  },
  "modal": {
    "type": "modal",
    "label": "Modal",
    "apis": [
      {
        "base": "https://api.modal.com"
      }
    ]
  },
  "monday": {
    "type": "monday",
    "label": "Monday.com",
    "apis": [
      {
        "base": "https://api.monday.com"
      }
    ]
  },
  "moss": {
    "type": "moss",
    "label": "Moss",
    "apis": [
      {
        "base": "https://api.moss.dev"
      }
    ]
  },
  "msg9": {
    "type": "msg9",
    "label": "msg9",
    "apis": [
      {
        "base": "https://www.msg9.io"
      }
    ]
  },
  "n8n": {
    "type": "n8n",
    "label": "n8n",
    "apis": [
      {
        "base": "${{ vars.N8N_BASE_URL }}/api/v1"
      }
    ]
  },
  "neon": {
    "type": "neon",
    "label": "Neon",
    "apis": [
      {
        "base": "https://console.neon.tech/api"
      }
    ]
  },
  "netdata": {
    "type": "netdata",
    "label": "Netdata",
    "apis": [
      {
        "base": "https://app.netdata.cloud"
      }
    ]
  },
  "notion": {
    "type": "notion",
    "label": "Notion",
    "apis": [
      {
        "base": "https://api.notion.com"
      }
    ]
  },
  "novita": {
    "type": "novita",
    "label": "Novita AI",
    "apis": [
      {
        "base": "https://api.novita.ai"
      }
    ]
  },
  "nyne": {
    "type": "nyne",
    "label": "Nyne",
    "apis": [
      {
        "base": "https://api.nyne.ai"
      }
    ]
  },
  "onyx": {
    "type": "onyx",
    "label": "Onyx",
    "apis": [
      {
        "base": "https://cloud.onyx.app"
      }
    ]
  },
  "openai": {
    "type": "openai",
    "label": "OpenAI",
    "apis": [
      {
        "base": "https://api.openai.com"
      }
    ]
  },
  "openrouter": {
    "type": "openrouter",
    "label": "OpenRouter",
    "apis": [
      {
        "base": "https://openrouter.ai"
      }
    ]
  },
  "openweather": {
    "type": "openweather",
    "label": "OpenWeather",
    "apis": [
      {
        "base": "https://api.openweathermap.org"
      }
    ]
  },
  "outlook-calendar": {
    "type": "outlook-calendar",
    "label": "Outlook Calendar",
    "apis": [
      {
        "base": "https://graph.microsoft.com"
      }
    ]
  },
  "outlook-mail": {
    "type": "outlook-mail",
    "label": "Outlook Mail",
    "apis": [
      {
        "base": "https://graph.microsoft.com"
      }
    ]
  },
  "pandadoc": {
    "type": "pandadoc",
    "label": "PandaDoc",
    "apis": [
      {
        "base": "https://api.pandadoc.com"
      }
    ]
  },
  "parallel": {
    "type": "parallel",
    "label": "Parallel",
    "apis": [
      {
        "base": "https://api.parallel.ai"
      }
    ]
  },
  "pdf4me": {
    "type": "pdf4me",
    "label": "PDF4me",
    "apis": [
      {
        "base": "https://api.pdf4me.com"
      }
    ]
  },
  "pdfco": {
    "type": "pdfco",
    "label": "PDF.co",
    "apis": [
      {
        "base": "https://api.pdf.co"
      }
    ]
  },
  "pdforge": {
    "type": "pdforge",
    "label": "PDForge",
    "apis": [
      {
        "base": "https://api.pdforge.com"
      }
    ]
  },
  "people-data-labs": {
    "type": "people-data-labs",
    "label": "People Data Labs",
    "apis": [
      {
        "base": "https://api.peopledatalabs.com"
      }
    ]
  },
  "perplexity": {
    "type": "perplexity",
    "label": "Perplexity",
    "apis": [
      {
        "base": "https://api.perplexity.ai"
      }
    ]
  },
  "pexels": {
    "type": "pexels",
    "label": "Pexels",
    "apis": [
      {
        "base": "https://api.pexels.com/v1"
      },
      {
        "base": "https://api.pexels.com/videos"
      },
      {
        "base": "https://images.pexels.com"
      },
      {
        "base": "https://videos.pexels.com"
      }
    ]
  },
  "pika": {
    "type": "pika",
    "label": "Pika",
    "apis": [
      {
        "base": "https://srkibaanghvsriahb.pika.art"
      },
      {
        "base": "https://7i30hpv4bo9ud5mhianq.pika.art"
      }
    ]
  },
  "pinecone": {
    "type": "pinecone",
    "label": "Pinecone",
    "apis": [
      {
        "base": "https://api.pinecone.io"
      }
    ]
  },
  "pipedream": {
    "type": "pipedream",
    "label": "Pipedream",
    "apis": [
      {
        "base": "https://api.pipedream.com"
      }
    ]
  },
  "pipedrive": {
    "type": "pipedrive",
    "label": "Pipedrive",
    "apis": [
      {
        "base": "https://api.pipedrive.com"
      }
    ]
  },
  "plain": {
    "type": "plain",
    "label": "Plain",
    "apis": [
      {
        "base": "https://core-api.uk.plain.com"
      }
    ]
  },
  "plausible": {
    "type": "plausible",
    "label": "Plausible",
    "apis": [
      {
        "base": "https://plausible.io/api"
      }
    ]
  },
  "podchaser": {
    "type": "podchaser",
    "label": "Podchaser",
    "apis": [
      {
        "base": "https://api.podchaser.com"
      }
    ]
  },
  "porkbun": {
    "type": "porkbun",
    "label": "Porkbun",
    "apis": [
      {
        "base": "https://api.porkbun.com/api/json/v3"
      },
      {
        "base": "https://api-ipv4.porkbun.com/api/json/v3"
      }
    ]
  },
  "posthog": {
    "type": "posthog",
    "label": "PostHog",
    "apis": [
      {
        "base": "https://us.posthog.com"
      },
      {
        "base": "https://eu.posthog.com"
      }
    ]
  },
  "printful": {
    "type": "printful",
    "label": "Printful",
    "apis": [
      {
        "base": "https://api.printful.com"
      }
    ]
  },
  "prisma-postgres": {
    "type": "prisma-postgres",
    "label": "Prisma Postgres",
    "apis": [
      {
        "base": "https://api.prisma.io"
      }
    ]
  },
  "productlane": {
    "type": "productlane",
    "label": "Productlane",
    "apis": [
      {
        "base": "https://productlane.com"
      }
    ]
  },
  "profound": {
    "type": "profound",
    "label": "Profound",
    "apis": [
      {
        "base": "https://api.tryprofound.com"
      }
    ]
  },
  "pushinator": {
    "type": "pushinator",
    "label": "Pushinator",
    "apis": [
      {
        "base": "https://api.pushinator.com"
      }
    ]
  },
  "qdrant": {
    "type": "qdrant",
    "label": "Qdrant",
    "apis": [
      {
        "base": "${{ vars.QDRANT_BASE_URL }}"
      }
    ]
  },
  "qiita": {
    "type": "qiita",
    "label": "Qiita",
    "apis": [
      {
        "base": "https://qiita.com"
      }
    ]
  },
  "quickbooks": {
    "type": "quickbooks",
    "label": "QuickBooks",
    "apis": [
      {
        "base": "https://quickbooks.api.intuit.com/v3/company/${{ vars.QUICKBOOKS_REALM_ID }}"
      }
    ]
  },
  "railway": {
    "type": "railway",
    "label": "Railway",
    "apis": [
      {
        "base": "https://backboard.railway.com"
      }
    ]
  },
  "railway-project": {
    "type": "railway-project",
    "label": "Railway Project",
    "apis": [
      {
        "base": "https://backboard.railway.com"
      }
    ]
  },
  "reap": {
    "type": "reap",
    "label": "Reap",
    "apis": [
      {
        "base": "${{ vars.REAP_API_BASE_URL }}"
      }
    ]
  },
  "recraft": {
    "type": "recraft",
    "label": "Recraft",
    "apis": [
      {
        "base": "https://external.api.recraft.ai"
      }
    ]
  },
  "reddit": {
    "type": "reddit",
    "label": "Reddit",
    "apis": [
      {
        "base": "https://oauth.reddit.com"
      }
    ]
  },
  "reducto": {
    "type": "reducto",
    "label": "Reducto",
    "apis": [
      {
        "base": "https://platform.reducto.ai"
      }
    ]
  },
  "render": {
    "type": "render",
    "label": "Render",
    "apis": [
      {
        "base": "https://api.render.com/v1"
      }
    ]
  },
  "rentcast": {
    "type": "rentcast",
    "label": "RentCast",
    "apis": [
      {
        "base": "https://api.rentcast.io/v1"
      }
    ]
  },
  "replicate": {
    "type": "replicate",
    "label": "Replicate",
    "apis": [
      {
        "base": "https://api.replicate.com"
      }
    ]
  },
  "reportei": {
    "type": "reportei",
    "label": "Reportei",
    "apis": [
      {
        "base": "https://app.reportei.com"
      }
    ]
  },
  "resend": {
    "type": "resend",
    "label": "Resend",
    "apis": [
      {
        "base": "https://api.resend.com"
      }
    ]
  },
  "revenuecat": {
    "type": "revenuecat",
    "label": "RevenueCat",
    "apis": [
      {
        "base": "https://api.revenuecat.com"
      }
    ]
  },
  "runway": {
    "type": "runway",
    "label": "Runway",
    "apis": [
      {
        "base": "https://api.dev.runwayml.com"
      }
    ]
  },
  "salesforce": {
    "type": "salesforce",
    "label": "Salesforce",
    "apis": [
      {
        "base": "https://${{ vars.SALESFORCE_INSTANCE }}.my.salesforce.com"
      }
    ]
  },
  "scrapeninja": {
    "type": "scrapeninja",
    "label": "ScrapeNinja",
    "apis": [
      {
        "base": "https://scrapeninja.p.rapidapi.com"
      }
    ]
  },
  "segment": {
    "type": "segment",
    "label": "Segment",
    "apis": [
      {
        "base": "https://api.segmentapis.com"
      }
    ]
  },
  "semrush": {
    "type": "semrush",
    "label": "Semrush",
    "apis": [
      {
        "base": "https://api.semrush.com"
      }
    ]
  },
  "sendgrid": {
    "type": "sendgrid",
    "label": "SendGrid",
    "apis": [
      {
        "base": "https://api.sendgrid.com"
      }
    ]
  },
  "sentry": {
    "type": "sentry",
    "label": "Sentry",
    "apis": [
      {
        "base": "https://sentry.io"
      }
    ]
  },
  "serpapi": {
    "type": "serpapi",
    "label": "SerpApi",
    "apis": [
      {
        "base": "https://serpapi.com"
      }
    ]
  },
  "servicenow": {
    "type": "servicenow",
    "label": "ServiceNow",
    "apis": [
      {
        "base": "https://${{ vars.SERVICENOW_INSTANCE }}.service-now.com"
      }
    ]
  },
  "shopify": {
    "type": "shopify",
    "label": "Shopify",
    "apis": [
      {
        "base": "https://${{ vars.SHOPIFY_SHOP }}.myshopify.com"
      }
    ]
  },
  "shortio": {
    "type": "shortio",
    "label": "Short.io",
    "apis": [
      {
        "base": "https://api.short.io"
      }
    ]
  },
  "similarweb": {
    "type": "similarweb",
    "label": "SimilarWeb",
    "apis": [
      {
        "base": "https://api.similarweb.com"
      }
    ]
  },
  "slack": {
    "type": "slack",
    "label": "Slack",
    "apis": [
      {
        "base": "https://slack.com/api"
      },
      {
        "base": "https://files.slack.com"
      }
    ]
  },
  "slack-webhook": {
    "type": "slack-webhook",
    "label": "Slack Webhook",
    "apis": [
      {
        "base": "https://firewall-placeholder.vm3.ai/slack-webhook/hook"
      }
    ]
  },
  "slock": {
    "type": "slock",
    "label": "Slock",
    "apis": [
      {
        "base": "https://api.slock.ai"
      }
    ]
  },
  "snowflake": {
    "type": "snowflake",
    "label": "Snowflake",
    "apis": [
      {
        "base": "https://${{ vars.SNOWFLAKE_ACCOUNT }}.snowflakecomputing.com/api"
      }
    ]
  },
  "sociavault": {
    "type": "sociavault",
    "label": "SociaVault",
    "apis": [
      {
        "base": "https://api.sociavault.com"
      }
    ]
  },
  "sponge": {
    "type": "sponge",
    "label": "Sponge",
    "apis": [
      {
        "base": "https://api.wallet.paysponge.com"
      }
    ]
  },
  "spotify": {
    "type": "spotify",
    "label": "Spotify",
    "apis": [
      {
        "base": "https://api.spotify.com"
      }
    ]
  },
  "sproutgigs": {
    "type": "sproutgigs",
    "label": "SproutGigs",
    "apis": [
      {
        "base": "https://sproutgigs.com/api"
      }
    ]
  },
  "square": {
    "type": "square",
    "label": "Square",
    "apis": [
      {
        "base": "https://connect.squareup.com"
      }
    ]
  },
  "stability-ai": {
    "type": "stability-ai",
    "label": "Stability AI",
    "apis": [
      {
        "base": "https://api.stability.ai"
      }
    ]
  },
  "strapi": {
    "type": "strapi",
    "label": "Strapi",
    "apis": [
      {
        "base": "${{ vars.STRAPI_BASE_URL }}"
      }
    ]
  },
  "strava": {
    "type": "strava",
    "label": "Strava",
    "apis": [
      {
        "base": "https://www.strava.com"
      }
    ]
  },
  "streak": {
    "type": "streak",
    "label": "Streak",
    "apis": [
      {
        "base": "https://api.streak.com"
      }
    ]
  },
  "stripe": {
    "type": "stripe",
    "label": "Stripe",
    "apis": [
      {
        "base": "https://api.stripe.com"
      }
    ]
  },
  "supabase": {
    "type": "supabase",
    "label": "Supabase",
    "apis": [
      {
        "base": "https://api.supabase.com"
      }
    ]
  },
  "supadata": {
    "type": "supadata",
    "label": "Supadata",
    "apis": [
      {
        "base": "https://api.supadata.ai"
      }
    ]
  },
  "supermemory": {
    "type": "supermemory",
    "label": "Supermemory",
    "apis": [
      {
        "base": "https://api.supermemory.ai"
      }
    ]
  },
  "tavily": {
    "type": "tavily",
    "label": "Tavily",
    "apis": [
      {
        "base": "https://api.tavily.com"
      }
    ]
  },
  "test-oauth": {
    "type": "test-oauth",
    "label": "Test OAuth (internal)",
    "apis": [
      {
        "base": "https://${{ vars.TEST_OAUTH_TENANT_ID }}.{pr}.vm6.ai/api/test/oauth-provider"
      },
      {
        "base": "https://{pr}.vm6.ai/api/test/oauth-provider"
      }
    ]
  },
  "testrail": {
    "type": "testrail",
    "label": "TestRail",
    "apis": [
      {
        "base": "https://${{ vars.TESTRAIL_INSTANCE }}.testrail.io"
      }
    ]
  },
  "ticketmaster": {
    "type": "ticketmaster",
    "label": "Ticketmaster",
    "apis": [
      {
        "base": "https://app.ticketmaster.com"
      }
    ]
  },
  "tiktok-ads": {
    "type": "tiktok-ads",
    "label": "TikTok Ads",
    "apis": [
      {
        "base": "https://business-api.tiktok.com"
      },
      {
        "base": "https://sandbox-ads.tiktok.com"
      }
    ]
  },
  "tldv": {
    "type": "tldv",
    "label": "tl;dv",
    "apis": [
      {
        "base": "https://pasta.tldv.io"
      }
    ]
  },
  "todoist": {
    "type": "todoist",
    "label": "Todoist",
    "apis": [
      {
        "base": "https://api.todoist.com"
      }
    ]
  },
  "together": {
    "type": "together",
    "label": "Together AI",
    "apis": [
      {
        "base": "https://api.together.ai"
      }
    ]
  },
  "tripo": {
    "type": "tripo",
    "label": "Tripo",
    "apis": [
      {
        "base": "https://api.tripo3d.ai"
      }
    ]
  },
  "twenty": {
    "type": "twenty",
    "label": "Twenty",
    "apis": [
      {
        "base": "https://api.twenty.com"
      }
    ]
  },
  "twilio": {
    "type": "twilio",
    "label": "Twilio",
    "apis": [
      {
        "base": "https://api.twilio.com"
      },
      {
        "base": "https://verify.twilio.com"
      },
      {
        "base": "https://lookups.twilio.com"
      },
      {
        "base": "https://messaging.twilio.com"
      },
      {
        "base": "https://studio.twilio.com"
      },
      {
        "base": "https://serverless.twilio.com"
      }
    ]
  },
  "typeform": {
    "type": "typeform",
    "label": "Typeform",
    "apis": [
      {
        "base": "https://api.typeform.com"
      }
    ]
  },
  "v0": {
    "type": "v0",
    "label": "v0",
    "apis": [
      {
        "base": "https://api.v0.dev"
      }
    ]
  },
  "vercel": {
    "type": "vercel",
    "label": "Vercel",
    "apis": [
      {
        "base": "https://api.vercel.com"
      }
    ]
  },
  "wandb": {
    "type": "wandb",
    "label": "Weights & Biases",
    "apis": [
      {
        "base": "https://api.wandb.ai"
      }
    ]
  },
  "webflow": {
    "type": "webflow",
    "label": "Webflow",
    "apis": [
      {
        "base": "https://api.webflow.com"
      }
    ]
  },
  "weread": {
    "type": "weread",
    "label": "WeRead",
    "apis": [
      {
        "base": "https://i.weread.qq.com"
      }
    ]
  },
  "whale-alert": {
    "type": "whale-alert",
    "label": "Whale Alert",
    "apis": [
      {
        "base": "https://leviathan.whale-alert.io"
      },
      {
        "base": "https://api.whale-alert.io/v1"
      }
    ]
  },
  "wix": {
    "type": "wix",
    "label": "Wix",
    "apis": [
      {
        "base": "https://www.wixapis.com"
      }
    ]
  },
  "workos": {
    "type": "workos",
    "label": "WorkOS",
    "apis": [
      {
        "base": "https://api.workos.com"
      }
    ]
  },
  "wrike": {
    "type": "wrike",
    "label": "Wrike",
    "apis": [
      {
        "base": "https://www.wrike.com"
      },
      {
        "base": "https://app-us2.wrike.com"
      },
      {
        "base": "https://app-eu.wrike.com"
      }
    ]
  },
  "x": {
    "type": "x",
    "label": "X",
    "apis": [
      {
        "base": "https://api.x.com"
      }
    ]
  },
  "xero": {
    "type": "xero",
    "label": "Xero",
    "apis": [
      {
        "base": "https://api.xero.com/Connections"
      },
      {
        "base": "https://api.xero.com/api.xro/2.0"
      },
      {
        "base": "https://api.xero.com/appstore/2.0"
      },
      {
        "base": "https://api.xero.com/assets.xro/1.0"
      },
      {
        "base": "https://api.xero.com/bankfeeds.xro/1.0"
      },
      {
        "base": "https://api.xero.com/files.xro/1.0"
      },
      {
        "base": "https://api.xero.com/finance.xro/1.0"
      },
      {
        "base": "https://api.xero.com/payroll.xro/1.0"
      },
      {
        "base": "https://api.xero.com/payroll.xro/2.0"
      },
      {
        "base": "https://api.xero.com/projects.xro/2.0"
      }
    ]
  },
  "youtube": {
    "type": "youtube",
    "label": "YouTube",
    "apis": [
      {
        "base": "https://youtube.googleapis.com/youtube"
      },
      {
        "base": "https://youtube.googleapis.com/upload/youtube"
      },
      {
        "base": "https://youtube.googleapis.com/resumable/upload/youtube"
      }
    ]
  },
  "zapier": {
    "type": "zapier",
    "label": "Zapier",
    "apis": [
      {
        "base": "https://actions.zapier.com"
      }
    ]
  },
  "zapsign": {
    "type": "zapsign",
    "label": "ZapSign",
    "apis": [
      {
        "base": "https://api.zapsign.com.br"
      }
    ]
  },
  "zendesk": {
    "type": "zendesk",
    "label": "Zendesk",
    "apis": [
      {
        "base": "https://${{ vars.ZENDESK_SUBDOMAIN }}.zendesk.com"
      }
    ]
  },
  "zep": {
    "type": "zep",
    "label": "Zep",
    "apis": [
      {
        "base": "https://api.getzep.com"
      }
    ]
  },
  "zeptomail": {
    "type": "zeptomail",
    "label": "ZeptoMail",
    "apis": [
      {
        "base": "https://api.zeptomail.com"
      }
    ]
  },
  "zoom": {
    "type": "zoom",
    "label": "Zoom",
    "apis": [
      {
        "base": "https://api.zoom.us"
      }
    ]
  }
} as const satisfies Readonly<Record<string, FirewallRoutingIndexMetadata>>;
